import { atom } from 'recoil';

const exifAtom = atom({
  key: 'exifAtom',
  default: null
});

export default exifAtom;
